import React from "react";
import SvgClose from "../../../assets/icons/SvgClose";
import SvgMenu from "../../../assets/icons/SvgMenu";
import { MobileMenuProvider } from "../../../context/NavMobileMenu";
import MobileMenu from "./MobileMenu";

export default function NavMenu({ isOpenMobileMenu, setOpenMobileMenu, data }) {
  return (
    <div className="block lg:hidden">
      <div
        className={`relative flex items-center text-[#111] group-hover:hover:text-secondary-500 cursor-pointer`}
        role="button"
        title="Menu"
        onClick={() => setOpenMobileMenu(!isOpenMobileMenu)}
      >
        {isOpenMobileMenu ? (
          <SvgClose style={{ width: "20px", height: "17px" }} />
        ) : (
          <SvgMenu style={{ width: "20px", height: "20px" }} />
        )}
      </div>
      <MobileMenuProvider>
        <MobileMenu
          isOpen={isOpenMobileMenu}
          setOpen={setOpenMobileMenu}
          data={data}
        />
      </MobileMenuProvider>
    </div>
  );
}
